var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"details"},[_c('mm-loading',{model:{value:(_vm.mmLoadShow),callback:function ($$v) {_vm.mmLoadShow=$$v},expression:"mmLoadShow"}}),_c('music-list',{attrs:{"list":_vm.list},on:{"select":_vm.selectItem}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }